module.exports = __webpack_public_path__ + "img/couples_03_V.77f3b69a.webp";